import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// material-ui components
import withStyles from "material-ui/styles/withStyles";
// @material-ui/icons
// core components
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import SectionContent from "./Sections/SectionContent";

import componentsStyle from "assets/jss/material-kit-react/views/components.jsx";

class MyStoryPage extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div>
        <Parallax image={require("assets/img/bg9.jpg")}>
          <div className={classes.container}>
            <GridContainer>
              <GridItem>
                <div className={classes.brand}>
                  <h1 className={classes.title}>My story</h1>
                  <h3 className={classes.subtitle}>
                    I'm a React Developer currently based in sunny Bali, Indonesia.
                  </h3>
                  <br/>
                  <h5 className={classes.subtitleparagraph}>
                  <strong>I enjoy turning complex problems into simple, 
                  beautiful and intuitive designs. When I'm not coding or 
                  designing, you'll find me travelling, 
                  photographing the world or enjoying great music.</strong>
                  </h5>
                </div>
              </GridItem>
            </GridContainer>
          </div>
        </Parallax>

        <div className={classNames(classes.main, classes.mainRaised)}>
              <SectionContent />
        </div>
        <Footer />
      </div>
    );
  }
}

export default withStyles(componentsStyle)(MyStoryPage);



// WEBPACK FOOTER //
// ./src/views/MyStoryPage/MyStoryPage.jsx